import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { convertRialToToman, composeClassNames } from 'Helpers';
import Button from 'Components/Globals/Elements/Button';
import Icon from 'Components/Globals/Elements/Icon';
import routes from '../../router/constants/routes';
import { walletPaymentSelectors } from 'Ducks';
import useContent from 'Hooks/useContent';

import styles from './styles.module.scss';
import strings from './strings';

function PaymentInformation() {
	const navigate = useNavigate();
	const { formatMessage } = useContent();

	const amount = useSelector(walletPaymentSelectors.selectAmount);
	return (
		<div className={styles.container}>
			<p className={composeClassNames(['txt-dark m-16', styles.wrapper])}>
				<span>{formatMessage(strings.amountTitle)}</span>
				<span className={styles.wrapper__amount}>
					{amount && convertRialToToman(amount).replaceAll(',', '،')}
					<Icon
						name={'toman'}
						className={`txt-dark mr-4`}
						size='xs'
					/>
				</span>
			</p>
			<p
				className={composeClassNames([
					'm-16 pv-12 ph-16 sm txt-dark',
					styles.description,
				])}
			>
				<span className='txt-text bold'>
					{formatMessage(strings.boldDescription)}
				</span>{' '}
				{formatMessage(strings.description)}
			</p>
			<div className={styles.wrapper_button}>
				<Button
					label={formatMessage(strings.nextStepButton)}
					onClick={() => navigate(routes.scanBarcode)}
					className={styles.wrapper_button__action}
				/>
				<p
					onClick={() => navigate(routes.factorAmount)}
					className={composeClassNames([
						'mt-4 mh-16 text-center pv-16 sm',
						styles.wrapper_button__action,
					])}
				>
					{formatMessage(strings.backButton)}
				</p>
			</div>
		</div>
	);
}

export default PaymentInformation;
